module.exports = __webpack_public_path__ + "static/logo_inprint-397820229b050abf55e6ec558b551b5c.svg";